import type { CardContext } from '@scale/compass-shared/types';
import { Steps } from '@scale/shared/types/ruleEngine/stepList';
import { DataCompassUtils } from 'react-scale/corp/views/DataCompassV2/dataCompassUtils';
import { type StepConfiguration, StepTypes } from '@scale/shared/types/ruleEngine/step';
import {
  type GenericAutoOpsContext,
  autoOpsCards,
} from '@scale/genai-compass-shared/autoops/cards';

export default function preprocessInitialContext(cardInput: CardContext, previousCardOutput: any) {
  const type = cardInput.cardType as keyof typeof autoOpsCards;
  // Handle generic auto ops cards
  // adds a processed auto ops step to the card input based on card type and previous card output
  if (type in autoOpsCards) {
    const shared = autoOpsCards[type];
    const autoOpsCardInput = cardInput as GenericAutoOpsContext<any>;
    const hasProcessedStep = autoOpsCardInput.hasProcessedStep;
    let currentStep = autoOpsCardInput.step as StepConfiguration<StepTypes>;
    if (!hasProcessedStep) {
      currentStep = DataCompassUtils.getProcessedGenericAutoOpsStep<any>(
        type,
        Steps[shared.stepType] as unknown as StepConfiguration<StepTypes>,
        previousCardOutput,
      );
      autoOpsCardInput.step = currentStep;
      autoOpsCardInput.hasProcessedStep = true;
    }
    autoOpsCardInput.step = currentStep;
    return autoOpsCardInput;
  } else {
    return cardInput;
  }
}
